export default "__VITE_ASSET__BOM6steq__"